import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { DevExtremeModule } from 'devextreme-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { GlobalService } from './services/global.service';
import { AuthService } from './services/auth.service';

import { OrchestraHomeComponent } from './orchestra-home/orchestra-home.component';
import { OrchestraLoginComponent } from './orchestra-login/orchestra-login.component';
import { OrchestraTopBarComponent } from './orchestra-top-bar/orchestra-top-bar.component';
import { FormsModule } from '@angular/forms';
import { GoogleLoginComponent } from './google-login/google-login.component';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { DashboardComponent } from './dashboard/dashboard.component';

@NgModule({
  declarations: [
    AppComponent,
    OrchestraHomeComponent,
    OrchestraLoginComponent,
    OrchestraTopBarComponent,
    GoogleLoginComponent,
    ImageViewerComponent,
    DashboardComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    DevExtremeModule,
  ],
  providers: [
    GlobalService,
    AuthService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
